"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const recoil_1 = require("recoil");
const reportElementTypes_1 = require("../../../domain/reportElementTypes");
const EmbedRoute_1 = __importDefault(require("../../../routes/EmbedRoute"));
const ReportsTableView_1 = __importDefault(require("../ReportTable/ReportsTableView"));
const ReportsTileView_1 = __importDefault(require("../ReportTiles/ReportsTileView"));
const ReportViewToggle_1 = require("../shared/ReportViewToggle");
const DashboardView = ({ getDashboardsFunction, headers, showViews = false, showPopular = false, showLastViewed = false, emptyState, handleErrors, }) => {
    const [dashboards, setDashboards] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const isMounted = (0, react_1.useRef)(true);
    const [toggleView] = (0, recoil_1.useRecoilState)(ReportViewToggle_1.tableTileViewSwitcherState);
    const setCount = (0, recoil_1.useSetRecoilState)(ReportViewToggle_1.recordCountTableState);
    const getDashboards = (0, react_1.useCallback)(() => {
        if (getDashboardsFunction) {
            let data;
            isMounted.current = true;
            setIsLoading(true);
            setCount(0);
            getDashboardsFunction()
                .then((response) => {
                data = response?.map((res) => {
                    return {
                        id: res.id,
                        name: res.title,
                        folder: res.folder.friendlyName,
                        folderId: res.folder.id,
                        elementType: reportElementTypes_1.ReportElementTypes.Dashboard,
                        contentFavoriteId: res.contentFavoriteId,
                        contentMetadataId: res.contentMetadataId,
                        createdAt: res.createdAt,
                        favoriteCount: res.favoriteCount > 0 ? res.favoriteCount : undefined,
                        viewCount: res.viewCount,
                        basePath: EmbedRoute_1.default.dashboardQueryString(res.folder.id, res.id),
                        lastViewed: res.lastViewedAt,
                        popularity: res.popularity,
                        createdBy: res.userName,
                        dashboards: 0,
                        looks: 0,
                        userId: res.userId,
                    };
                });
                setIsLoading(false);
                setDashboards(data);
                setCount(data?.length || 0);
            })
                .catch((err) => {
                setIsLoading(false);
                handleErrors(err);
            });
        }
    }, [getDashboardsFunction]);
    (0, react_1.useEffect)(() => {
        getDashboards();
        return () => {
            isMounted.current = false;
        };
    }, [getDashboards]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        toggleView === 'table' && (react_1.default.createElement(ReportsTableView_1.default, { id: "dashboardTable", isLoading: isLoading, headers: headers, data: dashboards ?? [], showViews: showViews, showLastViewed: showLastViewed, showPopular: showPopular, emptyState: emptyState })),
        toggleView === 'tile' && (react_1.default.createElement(ReportsTileView_1.default, { isLoading: isLoading, data: dashboards ?? [], id: "dashboardTiles", emptyState: emptyState }))));
};
exports.default = DashboardView;
